/**
 * @module actions/carownerportal
 */
import axios from 'axios'
import { queueUpload } from '../utils/upload'
import { setAuthorizationToken, setDeviceToken } from '../utils/setAuthorizationToken'
import { setLanguageAction } from '../language/actions'
import {
  API_URL,
  FILE_STORAGE_API,
  SET_CURRENT_USER
} from '../constants'

/**
 * @description enable car owner portal access
 * @return {Promise} Axios promise
 */
export function enableCarOwnerPortalAccess (data) {
  let url = API_URL + '/CarOwnerPortal/EnableCarOwnerPortalAccess'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description upload logo
 * @return {Promise} Axios promise
 */
export function uploadLogo (file) {
  let url = FILE_STORAGE_API + '/CompanyStyling/UploadLogo'
  let data = new window.FormData()
  data.append(file.name, file)
  return queueUpload(url, file, data)
}

/**
 * @description get logo
 * @return {Promise} Axios promise
 */
export function getLogo () {
  let url = API_URL + '/CompanyStyling/GetLogo'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description delete logo
 * @return {Promise} Axios promise
 */
export function deleteLogo () {
  let url = API_URL + '/CompanyStyling/DeleteLogo'
  return dispatch => {
    return axios.delete(url)
  }
}

/**
 * @description GetStatus/{orderId}
 * @return {Promise} Axios promise
 */
export function getCarOwnerStatus (orderId) {
  return dispatch => {
    return axios.get(`${API_URL}/CarOwnerPortal/GetStatus/${orderId}`)
  }
}
/**
 * @description UpdateCarOwner
 * @return {Promise} Axios promise
 */
export function updateCarOwner (data) {
  let url = API_URL + '/CarOwnerPortal/UpdateCarOwner'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description get logo
 * @return {Promise} Axios promise
 */
export function getTimeLineStatus (orderId) {
  let url = API_URL + `/CarOwnerPortal/GetTimeLineStatus/${orderId}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description SendInvitation
 * @return {Promise} Axios promise
 */
export function sendInvitation (data) {
  let url = API_URL + '/CarOwnerPortal/SendInvitation'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description verify token
 * @return {Promise} Axios promise
 */
export function tokenLogin (token) {
  window.localStorage.clear()
  return dispatch => {
    return axios.post(`${API_URL}/CarOwnerPortal/Login/${token}`).then(res => {
      const token = res.data.Token
      window.localStorage.setItem('user_token', token)
      window.localStorage.setItem('user_data', JSON.stringify(res.data))
      setAuthorizationToken(token)
      setDeviceToken(res.data.DeviceToken)
      dispatch(setCurrentUser(res.data))
      if (!window.localStorage.user_language) {
        window.localStorage.setItem('user_language', res.data.DefaultLanguage)
        dispatch(setLanguageAction(res.data.DefaultLanguage))
      }

      return res
    })
  }
}

/**
 * @description set acceptance of terms of service
 * @return {Promise} Axios promise
 */
export function acceptTOS (data) {
  return dispatch => {
    return axios.post(`${API_URL}/CarOwnerPortal/AcceptTOS`, data)
  }
}

function setCurrentUser (user) {
  return {
    type: SET_CURRENT_USER,
    user
  }
}

export function logout () {
  return dispatch => {
    window.localStorage.removeItem('user_token')
    window.localStorage.removeItem('user_data')
    window.localStorage.removeItem('user_language')
    setAuthorizationToken(false)
    setDeviceToken(false)
    dispatch(setCurrentUser({}))
  }
}




// WEBPACK FOOTER //
// ./src/app/actions/carownerportal.js